import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import Cookie from "js-cookie"
import { useUserContext } from "../context/UserContext"
import AuthApi from "../api/AuthApi"
import { ACCESS_TOKEN } from "../constants/userConstants"
import RoutePermission from '../guards/RoutePermission'
/* eslint-disable react/prop-types */
const AuthGuard = ({component, navId}) => {/* eslint-disable react/prop-types */
    const navigate = useNavigate()
    const { getSessionUser } = useUserContext()
    const { updateSessionUser} = useUserContext()
    const location = useLocation()
    const path = location?.pathname?.split('/')[1] || ''

    const cleanLogin = () => {
        Cookie.remove(ACCESS_TOKEN)
        window.location.href='/login'
    }

    useEffect(() => {
        const refreshMemberSession = async () => {
            const member = await AuthApi.getSessionMember()
            if (member) {
                updateSessionUser(member)
                if (!RoutePermission.checkItemAllow(member, path)) {
                    console.log('Error: Auth refreshMemberSession failed')
                    window.location.href='/404'
                }
            } else {
                cleanLogin()
            }
        }
        const token =  Cookie.get(ACCESS_TOKEN)
        if (token) {
            // check if refresh page clause usercontext lost
            const sessionUser = getSessionUser()
            if (sessionUser) {
                if (!RoutePermission.checkItemAllow(sessionUser, path)) {
                    console.log('Error: Auth token getSessionUser failed path:' + path)
                    window.location.href='/404'
                }
            } else {
                refreshMemberSession()
            }
        } else {
            cleanLogin()
        }
    }, [getSessionUser, navigate, updateSessionUser, navId])

    return <React.Fragment>{component}</React.Fragment>
}

export default AuthGuard